const ProgressBar = ({ progress }: { progress: number }) => (
  <div className='w-full p-1 border border-gray-200'>
    <div className={`bg-primary h-2`} style={{ width: `${progress}%` }} />
  </div>
)

export default ProgressBar